// extracted by mini-css-extract-plugin
export default {"flexColumn":"FlexColumnDiv_flexColumn__z6RTa"};